var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-item flex-row flex-left margin-bottom-10 clickable has-border__bottom",on:{"click":_vm.click}},[_c('i',{staticClass:"far fa-file color__link font-size__small margin-bottom-10 margin-right-10"}),_vm._v(" "),_c('span',{class:_vm.item.isSeen
        ? 'file-name  padding-bottom-10'
        : 'file-name  padding-bottom-10 font-weight__bold'},[_vm._v(_vm._s(_vm.item.quote))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-015ec47c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/doc-dashboard-card-item.vue
// module id = null
// module chunks = 